import * as types from "@/store/types";
import { MarketMarketService } from "@/services";

const state = {
  currentCoin: null,
  coinScales: [],
  selectedPrice: null
};

const getters = {
  [types.marketExchange.getters.GET_CURRENT_COIN]: state => {
    return state.currentCoin;
  },
  [types.marketExchange.getters.GET_COIN_SCALES]: state => {
    return state.coinScales;
  },
  [types.marketExchange.getters.GET_SELECTED_PRICE]: state => {
    return state.selectedPrice;
  }
};

const mutations = {
  [types.marketExchange.mutations.MUTATE_CURRENT_COIN]: (state, payload) => {
    state.currentCoin = payload;
  },
  [types.marketExchange.mutations.MUTATE_COIN_SCALES]: (state, payload) => {
    state.coinScales = payload;
  },
  [types.marketExchange.mutations.MUTATE_SELECTED_PRICE]: (state, payload) => {
    state.selectedPrice = payload;
  }
};

const actions = {
  [types.marketExchange.actions.SET_CURRENT_COIN]: ({ commit }, payload) => {
    MarketMarketService.getSymbolInfo({ symbol: payload.symbol }).then(
      async res => {
        await commit(types.marketExchange.mutations.MUTATE_CURRENT_COIN, {
          ...res.data,
          ...payload
        });
      }
    );
  },

  [types.marketExchange.actions.SET_COIN_SCALES]: ({ commit }, payload) => {
    commit(types.marketExchange.mutations.MUTATE_COIN_SCALES, payload);
  },

  [types.marketExchange.actions.SET_SELECTED_PRICE]: ({ commit }, payload) => {
    commit(types.marketExchange.mutations.MUTATE_SELECTED_PRICE, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
